var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomePageNoImageFormat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8A8A8A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 5.333,
    rx: 2.667,
    transform: "translate(.849 29.333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 5.333,
    rx: 2.667,
    transform: "translate(.849 9.333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 5.333,
    rx: 2.667,
    transform: "translate(.849)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 5.333,
    rx: 2.667,
    transform: "translate(.849 39.111)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 5.333,
    rx: 2.667,
    transform: "translate(.849 19.111)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 5.333,
    rx: 2.667,
    transform: "translate(.849 48.889)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 5.333,
    rx: 2.667,
    transform: "translate(.849 58.667)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageNoImageFormat);
export default __webpack_public_path__ + "static/media/HomePageNoImageFormat.7d9d8b84.svg";
export { ForwardRef as ReactComponent };